export const TIER_RANK = { silver: 0, gold: 1, diamond: 2 };
export const TIER_NAME = { silver: "Silver Serenity", gold: "Gold Genesis", diamond: "Diamond Dharma" };
export const TIER_LABEL = { silver: "Silver", gold: "Gold", diamond: "Diamond" };

export const TIERS = [
  {
    id: "silver",
    name: "Silver Serenity",
    price: "Free",
    priceSub: "Always free",
    image: "/api/media/1b7de307-8938-4bc3-8b4e-6c45f4364376",
    accent: "#718078",
    launch: false,
    button: "Start Free Silver Serenity",
    features: [
      "Limited resources available",
      "4 Videos access",
      "Discovery consultation (20 min)",
      "Intro access to teachings",
      "Free Healing Blueprint Guide",
    ],
    includes: null,
  },
  {
    id: "gold",
    name: "Gold Genesis",
    price: "$25",
    priceSub: "Lifetime",
    image: "/api/media/673df044-cb84-4d47-8cbe-aadf0eb0153f",
    accent: "#C59B27",
    launch: true,
    button: "Become Gold Genesis",
    features: [
      "Structured resource set",
      "10 Videos access",
      "5 consultations per year",
      "Structured learning path",
      "Seasonal guidance",
      "Free Ebook: Shaping Our Destiny",
    ],
    includes: "Includes everything in Silver",
  },
  {
    id: "diamond",
    name: "Diamond Dharma",
    price: "$50",
    priceSub: "Lifetime",
    image: "/api/media/399dcd2f-e938-41d3-920b-1b5b0b0033de",
    accent: "#4F8176",
    launch: true,
    button: "Become Diamond Dharma",
    features: [
      "Unlimited resources",
      "All 23 videos access",
      "10 consultations per year",
      "Full training library access",
      "Emotional mastery teachings",
      "Free Ebook: Shaping Our Destiny + priority booking",
    ],
    includes: "Includes everything in Silver + Gold",
  },
];

export function nextTier(tier) {
  if (tier === "silver") return "gold";
  if (tier === "gold") return "diamond";
  return null;
}
